import APIController from '../core-api-controller';

export const fetchCasesApi = (paramsObj = {}, paramsStr = '') => {
  const path = `${APIController.endpointApi}/cases${paramsStr ? paramsStr : ''}`;
  return APIController.getApiCallback(path, paramsObj);
};

export const submitManualReviewApi = ({ id = '', data = {} }) => {
  const path = `${APIController.endpointApi}/telegramd/cases/${id}/submit`;
  return APIController.postCallback(path, data);
};

export const updateCaseApi = ({ id = '', data = {} }) => {
  const path = `${APIController.endpointApi}/cases/${id}`;
  return APIController.putCallback(path, data);
};

export const linkChargeApi = (id = '', data = {}) => {
  const path = `${APIController.endpointApi}/cases/${id}/link_charge`;
  return APIController.putCallback(path, data);
};

export const unlinkChargeApi = (id = '') => {
  const path = `${APIController.endpointApi}/cases/${id}/unlink_charge`;
  return APIController.putCallback(path);
};

export const pauseFollowupApi = (id = '', data = {}) => {
  const path = `${APIController.endpointApi}/cases/${id}/pause_followup`;
  return APIController.putCallback(path, data);
};

export const fetchCaseNextFollowUpApi = (caseId = {}) => {
  const path = `${APIController.endpointApi}/cases/${caseId}/next_followup`;
  return APIController.getApiCallback(path);
};

export const markMainProductApi = (id = '', data = {}) => {
  const path = `${APIController.endpointApi}/cases/${id}/mark_main_product`;
  return APIController.putCallback(path, data);
};
